module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view>Loading&hellip;</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 843
// module chunks = 0